import React from 'react'
import TownListContainer from '../../templates/town-list/TownListContainer'
import Navbar from '../../templates/navbar/Navbar'

const TownListPage = props => (
  <div>
    <Navbar />
    <div className="container">
      <div className="section">
        <div className="section">
          <div className="title is-3">Town List</div>
        </div>
        <TownListContainer {...props} />
      </div>
    </div>
  </div>
)

export default TownListPage



// WEBPACK FOOTER //
// ./src/components/pages/web/TownListPage.js